import { GetProductsResponse } from '@ph-model/response/getproducts.response';

export function applyProductCategoryOverrides(
  response: GetProductsResponse,
  overrides: Record<string, string> | undefined
): GetProductsResponse {
  if (!overrides || !Object.keys(overrides).length) {
    return response;
  }

  const products = response?.availableOptions?.products?.productItem;
  if (!products?.length) {
    return response;
  }

  products.forEach((product) => {
    const overrideCategory = overrides[product.productCode];
    if (overrideCategory) {
      product.productCategory = overrideCategory;
      product.markupProductType = overrideCategory;
    }
  });

  return response;
}
